import {
  FetchReferralParams,
  ListData,
  Referral,
  ReferralStatistic,
} from "@/types";
import axiosInstance from "./api";

export function fetchListReferralService(
  params: FetchReferralParams,
): Promise<ListData<Referral>> {
  return axiosInstance
    .get("/reward/admin/referral", { params })
    .then((response) => response.data);
}

export function fetchReferralStatisticService(): Promise<ReferralStatistic> {
  return axiosInstance
    .get("/reward/admin/statistic")
    .then((response) => response.data);
}
